import React, { useRef, useState, useLayoutEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import "./SelectInput.css";

export const SelectInput = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Selecione uma opção",
  error = "",
  maxHeight = 300, // Simple default height
  openUpward = null, // null = auto, true = force up, false = force down
  container = null, // Container para renderizar o dropdown
}) => {
  const selectRef = useRef(null);
  const [selectWidth, setSelectWidth] = useState('auto');

  // Calculate width after component mounts and on window resize
  useLayoutEffect(() => {
    const calculateWidth = () => {
      if (selectRef.current) {
        const rect = selectRef.current.getBoundingClientRect();
        if (rect.width > 0) {
          setSelectWidth(rect.width + 'px');
        }
      }
    };

    calculateWidth();
    window.addEventListener('resize', calculateWidth);

    return () => window.removeEventListener('resize', calculateWidth);
  }, []);

  const getMenuProps = () => {
    let isUpward = false;

    // Auto-detect direction if not forced
    if (openUpward === null && selectRef.current) {
      const rect = selectRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // Open upward if not enough space below but enough above
      isUpward = spaceBelow < maxHeight && spaceAbove > maxHeight;
    } else if (openUpward !== null) {
      isUpward = openUpward;
    }

    const menuProps = {
      PaperProps: {
        style: {
          maxHeight: maxHeight,
          minWidth: selectWidth,
          width: selectWidth,
          maxWidth: selectWidth,
        },
      },
      anchorOrigin: {
        vertical: isUpward ? 'top' : 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: isUpward ? 'bottom' : 'top',
        horizontal: 'left',
      },
      getContentAnchorEl: null,
      disableAutoFocusItem: true,
    };

    // Se um container foi fornecido, adiciona ao MenuProps
    if (container) {
      menuProps.container = container;
    }

    return menuProps;
  };

  return (
    <div className="selectInputWrapper">
      {label && <label className="selectLabel" htmlFor={name}>{label}</label>}
      <div className="select-wrapper" ref={selectRef}>
        <FormControl fullWidth error={!!error}>
          <Select
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            displayEmpty
            className="selectInput"
            MenuProps={getMenuProps()}
            renderValue={(selected) => {
              if (!selected) return <span className="placeholder">{placeholder}</span>;
              const selectedOption = options.find((opt) => opt.value === selected);
              return selectedOption?.label || selected;
            }}
          >
            <MenuItem disabled value="">
              <em>{placeholder}</em>
            </MenuItem>
            {options.map(({ label, value }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
          {error && <p className="textError">{error}</p>}
        </FormControl>
      </div>
    </div>
  );
};
